import { render, staticRenderFns } from "./OrganizerRegistration.vue?vue&type=template&id=234a309a&scoped=true&"
import script from "./OrganizerRegistration.vue?vue&type=script&lang=js&"
export * from "./OrganizerRegistration.vue?vue&type=script&lang=js&"
import style0 from "./OrganizerRegistration.vue?vue&type=style&index=0&id=234a309a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234a309a",
  null
  
)

export default component.exports